import React from 'react';
import SetLicenseAction from "../license/SetLicenseAction";
import StatusToolbar from '../status/StatusToolbar';
import UserToolbar from "../auth/UserToolbar";

import "./TopToolbar.scss";
import {WorkbenchStateContext} from "../context/WorkbenchContext";

/**
 * Sticky toolbar rendering in the top right cornet
 */
class TopToolbar extends React.Component {

  static contextType = WorkbenchStateContext;

  render() {
    return (
      <div className="TopToolbar">
        <div className="TopToolbarContent">
          <SetLicenseAction/>
          <StatusToolbar configurations={this.context.configurations}/>
          <UserToolbar className="ml-1"/>
        </div>
      </div>
    );
  }
}

export default TopToolbar;
